// extracted by mini-css-extract-plugin
module.exports = {"slideItem":"LifeatVahakImage_slideItem__YEYkb"};